import type { ReactNode } from "react";
import { Outlet } from "react-router";
import { SiteHeader } from "@/components/SiteHeader/SiteHeader";

export const DefaultPageLayout = (): ReactNode => {
    return (
        <div className="relative flex flex-col">
            <SiteHeader />
            <Outlet />
        </div>
    );
};
